
import moment from 'moment';

export const formatDate = (epoch: number | null): string => {
    if (epoch == null) {
        return "unknown"
    }

    return moment(Number(epoch)).format('MMMM Do Y')
}

export const formatDateForBirth = (epoch: number): string=> {
    return moment(Number(epoch)).format('MM-DD-YYYY')
}

export const formatDateTime = (epoch: number): string => {
    return moment(Number(epoch)).format('ddd, MMMM Do - hh:mm a')
}

export const formatDateTimeToDay = (epoch: number): string => {
    return moment(Number(epoch)).format('MMMM Do')
}
